




































import Vue from "vue";
import Component from "vue-class-component";

@Component({
  props: {
    graphData: Array,
  },
})
export default class WeatherDataGraph extends Vue {
  private graphData: any;
  private graphSeries: any = [];
  private graphKey = 0;
  private isActive = [false, false, false, false];
  private yLabel = "Humidity (g/m3)";
  private yData = {
    title: {
      text: this.yLabel,
    },
    labels: {
      formatter: function () {
        return (this as any).value;
      },
    },
  };

  private chartOptions = {
    title: {
      text: "",
    },
    chart: {
      type: "line",
      zoomType: 'x',
    },
    subtitle: {
      text: "",
    },
    tooltip: {
      formatter: function () {
        const time = new Date((this as any).x * 1000);
        const monthNames = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        let minutes = time.getMinutes();
        let hour = time.getHours();
        let date = time.getDate();
        let month = time.getMonth();
        let minutesString = "";
        let hourString = "";
        if (minutes < 10) {
          minutesString = "0" + minutes.toString();
        } else {
          minutesString = minutes.toString();
        }
        if (hour < 10) {
          hourString = "0" + hour.toString();
        } else {
          hourString = hour.toString();
        }
        return (
          this.series.name +
          "</b><br>" +
          "Time: <b>" +
          date +
          "  " +
          monthNames[month] +
          "  " +
          hourString +
          ":" +
          minutesString +
          "<br>Value: <b>" +
          Math.round((this as any).y) +
          "</b>"
        );
      },
    },
    exporting: {
      enabled: true,
      csv: {
        columnHeaderFormatter: null,
        dateFormat: "%Y-%m-%d %H:%M:%S",
        decimalPoint: null,
        itemDelimiter: null,
        lineDelimiter: " ",
      },
      buttons: {
        contextButton: {
          menuItems: ["downloadPNG", "downloadSVG", "downloadXLS"],
        },
      },
    },
    yAxis: this.yData,
    xAxis: {
      title: {
        text: "Time",
      },
      labels: {
        formatter: function () {
          const monthNames = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
          ];
          const time = new Date((this as any).value * 1000);
          let minutes = time.getMinutes();
          let hour = time.getHours();
          let date = time.getDate();
          let month = time.getMonth();
          let minutesString = "";
          let hourString = "";
          if (minutes < 10) {
            minutesString = "0" + minutes.toString();
          } else {
            minutesString = minutes.toString();
          }
          if (hour < 10) {
            hourString = "0" + hour.toString();
          } else {
            hourString = hour.toString();
          }
          return (
            date +
            "  " +
            monthNames[month] +
            "  " +
            hourString +
            ":" +
            minutesString
          );
        },
      },
    },
    legend: {
      enabled: false,
    },

    plotOptions: {
      series: {
        label: {
          connectorAllowed: false,
        },
      },
    },

    series: this.graphSeries,

    responsive: {
      rules: [
        {
          condition: {
            maxWidth: 500,
          },
          chartOptions: {
            legend: {
              layout: "horizontal",
              align: "center",
              verticalAlign: "bottom",
            },
          },
        },
      ],
    },
  };

  changeData(x) {
    this.graphSeries.length = 0;
    for (let i = 0; i < 4; i++) {
      if (i == x) this.isActive[i] = true;
      else this.isActive[i] = false;
    }
    if (x == 0) {
      this.yLabel = "Humidity (g/m³)";
      let data = [];
      for (let i = 0; i < this.graphData.length; i++) {
        data.push([
          this.graphData[i].timestamp,
          this.graphData[i].humidity,
        ] as never);
      }

      if (this.graphData.length > 0) {
        this.graphSeries.push({
          name: 'Humidity (g/m³)',
          data: data,
          visible: false,
        });
      }
    } else if (x == 1) {
      this.yLabel = "Solar Radiation (W/m²)";
      let data = [];
      for (let i = 0; i < this.graphData.length; i++) {
        data.push([
          this.graphData[i].timestamp,
          this.graphData[i].solar_radiation,
        ] as never);
      }

      if (this.graphData.length > 0) {
        this.graphSeries.push({
          name: 'Solar Radiation (W/m²)',
          data: data,
          visible: false,
        });
      }
    } else if (x == 2) {
      this.yLabel = "Temperature (°C)";
      let data = [];
      for (let i = 0; i < this.graphData.length; i++) {
        data.push([
          this.graphData[i].timestamp,
          this.graphData[i].temperature,
        ] as never);
      }

      if (this.graphData.length > 0) {
        this.graphSeries.push({
          name: 'Temperature (°C)',
          data: data,
          visible: false,
        });
      }
    } else if (x == 3) {
      this.yLabel = "Wind Speed (m/s)";
      let data = [];
      for (let i = 0; i < this.graphData.length; i++) {
        data.push([
          this.graphData[i].timestamp,
          this.graphData[i].wind_speed,
        ] as never);
      }

      if (this.graphData.length > 0) {
        this.graphSeries.push({
          name: 'Wind Speed (m/s)',
          data: data,
          visible: false,
        });
      }
    }

    this.chartOptions.yAxis = {
      title: {
        text: this.yLabel,
      },
      labels: {
        formatter: function () {
          return (this as any).value;
        },
      },
    };

    this.graphSeries[0].visible = true;

    this.graphKey++;
  }

  mounted() {
    setTimeout(() => this.changeData(0), 1000);
  }

  updated() {}
}
